import styled from 'styled-components';
import { Typography } from '@mui/material';
import {BrandCode} from 'types/Brand'
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import fonts from 'styles/fonts';

export const Container = styled.div`
  font-size: 18px;
  line-height: 22px;
`;

export const LoggedWelcomeInfo = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  color: ${colors.functional.softGrey};
  display: flex;
  flex-direction: row;
  @media (max-width: ${sizes.media.smallMaxWidth}px) {
    flex-direction: column;
  }
`;

export const LoggedHeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    flex-direction: row;
  }
`

export const LoggedLabelAs = styled.p`
  color: ${({ palette }) => palette?.secondary.main};

  ${({ theme }) =>
  ({
    [BrandCode.RoyalCaribbean]: `
  font-family: ${theme.typography.fontFamilyBold};
  font-size: 20px;
`,
    [BrandCode.Celebrity]: `
  font-family: ${theme.typography.fontFamilySemiBold};
  font-size: 18px;
`,
  })[theme.brandCode]}
`;

export const LoggedSwitch = styled.span`
  flex-basis: 100%;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    font-family: ${({theme}) => theme.typography.fontFamilyBold};
    font-size: 18px;
    line-height: 22px;
    flex-basis: unset;
    display: inline-flex;
  }
`;

export const LoggedLabelId = styled(LoggedLabelAs)`
`;

export const LoggedLabelSwitch = styled.a`
  font-size: 16px;
  line-height: 19.5px;
  font-weight: 400;
  margin-top: 2px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${colors.functional.blueButton};
`;

export const LoggedLabelSymbol = styled(LoggedLabelSwitch)`
  color: ${({palette}) => palette?.secondary.main};
`;

export const LoggedOffersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 40px 50px;
  gap: 10px;
  background: ${colors.functional.paleGrey};
  border-radius: 5px;
  @media (max-width: ${sizes.media.tabletPortrait}px) {
    width: 100%;
    min-height: 132px;
    height: auto;
    padding: 30px 20px;
  }
`;

export const LoggedNoOffersInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${colors.secondary.deepCove};
  text-align: center;
  height: 140px;
  width: 100%;
  white-space: pre-wrap;
  @media (max-width: ${sizes.media.tabletPortrait}px) {
    font-size: 16px;
    height: 132px;
  }
  @media (max-width: ${sizes.media.xSmallMaxWidth}px) {
    white-space: normal;
  }
`;

export const Label = styled(Typography)`
  &.isMobile {
    @media (max-width: ${sizes.media.smallMaxWidth}px) {
      font-size: 14px;
      line-height: 17px;
    }
  }
`;

export const LoggedCrownAndAnchor = styled.a`
  color: ${colors.functional.blueButton};
  cursor: pointer;
`;

export const LoggedSignInNow = styled.a`
  font-family: ${fonts.primary.semibold};
  font-size: 18px;
  line-height: 17.05px;
  color: ${colors.functional.blueButton};
  cursor: pointer;
  margin-top: 10px;
`;

export const LoggedNoOffersInfoMessage = styled.span`
  font-family: ${fonts.primary.semibold};
  font-size: 20px;
  line-height: 150%;
  white-space: normal;
  text-align: center;

  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    margin-left: 11%;
    margin-right: 11%;
  }
  ${LoggedSignInNow} {
    font-size: 20px;
    font-family: ${fonts.primary.semibold};
    padding-left: 5px;
    color: ${colors.primary.ocean};
    cursor: pointer;
    text-decoration: underline;
    @media (max-width: ${sizes.media.smallMaxWidth}px) {
      display: block;
      margin-top: 0;
    }
    @media (max-width: ${sizes.media.tabletPortrait}px) {
      margin-top: 0;
      font-size: 16px;
    }
  }
`;
